import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "./ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../Actions/landingAction";


const CandidateTab = ({ activeTab, onTabClick }) => {

  const [details, setDetails] = useState([]);
  const [checkLength, setCheckLength] = useState();
  const [completePercentage, setCompletePercentage] = useState(0);
  // const storeLandingData = useSelector((state) => state.landingPage);
  const InsuffState = useSelector((state) => state?.Insuff);
  const iconPack = {
    "2": "icon fas fa-map-location-dot",
    "3": "icon fas fa-book",
    "4": "icon fas fa-briefcase",
    "5": "icon fas fa-thumbs-up",
    "6": "icon fas fa-thumbs-up",
    "7": "icon fas fa-user-shield",
    "8": "icon fas fa-landmark",
    "9": "icon fas fa-rectangle-list",
    "10": "icon fas fa-vial-circle-check",
    "12": "icon fas fa-file-contract",
    "13": "icon fas fa-staff-snake",
    "14": "icon fas fa-clipboard-check",
    "15": "icon fas fa-user-shield",
    "18": "icon fas fa-map-location-dot",
    "eaadhar": "icon fas fa-address-card",
    "nid":"icon fa-solid fa-shield-halved",
  }

  const dispatch = useDispatch();

  useEffect(() => {
    const pageData = async () => {
      dispatch(getData());
    };

    pageData();
  }, []);

  const navTab = useRef();

  const [reference, setReference] = useState();

  useEffect(() => {
    let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
    setReference(list.reference_number);

  }, []);
 
  useEffect(() => {
    let link = navTab?.current?.querySelector(".active");
    if (link) {
      link.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "end",
      });
    }
  }, [activeTab]);

  return (
    <>

      {<nav id="nav" ref={navTab} className="main-menu">
      <div className="nav nav-tabs flex-column" id="nav-tab" role="tablist">
          {
            InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails &&
            Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails)?.map((insuffData, index) => {
              // console.log("insuff status...",insuffData[1]?.CaseInsuffDetail?.INSUFF_STATUS)
              if(insuffData[1]?.CaseInsuffDetail?.INSUFF_STATUS == 1) {
                let className = "icon fas fa-briefcase"
                if(insuffData[1]?.group_id
                  && iconPack[`${insuffData[1]?.group_id}`]){
                  className = iconPack[`${insuffData[1]?.group_id}`]
                }
                return (
                  <Link
                    className={
                      activeTab === `${insuffData[1]?.CaseInsuffDetail?.INSUFF_ID}`
                        ? "nav-item nav-link fnt-smi-bld active "
                        : "nav-item nav-link fnt-smi-bld "
                    }
                    style={
                      {
                        width: '100%'
                      }
                    }
                    id="nav-personal-details-tab"
                    to={``}
                    name={`${insuffData[1]?.CaseInsuffDetail?.INSUFF_ID}`}
                  >
                    {activeTab === insuffData[1]?.CaseCheck?.CHECK_NAME && (
                    <span class="tab-count">{index + 1}</span>
                  )}
                    <span>
                      <span className={className}></span>
                      <span className="title"
                        name={`${insuffData[1]?.CaseInsuffDetail?.INSUFF_ID}`}
                        value={`${insuffData[1]?.CaseCheck?.CHECK_NAME}`}
                        onClick={(e) => {
                          onTabClick(e,insuffData[1]?.CaseInsuffDetail?.INSUFF_ID)
                        }
                        }
                      >{`${insuffData[1]?.CaseCheck?.CHECK_NAME}`} { insuffData[1]?.InsufficiencyRespondedCase?.STATUS=='1'?
                        <i class="fa-solid fa-check" style={{color:'green'}}></i>:''}
                      </span>
  
                    </span>
                  </Link>)
              } else {
                return 
              }
            }
            )

          }

        </div>
      </nav>}

    </>
  );
};

export default CandidateTab;
